import type { Tone } from "@/components/ui/pill";
import type { EvaluatorCategory, EvaluatorKind } from "./types";

/** The UI groups from the TRD: answer quality, grounding, agent behaviour, safety, custom. */
export const CATEGORY_LABEL: Record<EvaluatorCategory, string> = {
  answer_quality: "Answer quality",
  grounding: "Grounding",
  agent_behaviour: "Agent behaviour",
  safety: "Safety",
  custom: "Custom",
};

export const CATEGORY_ORDER = Object.keys(CATEGORY_LABEL) as EvaluatorCategory[];

export const KIND: Record<EvaluatorKind, { label: string; tone: Tone }> = {
  llm_judge: { label: "LLM judge", tone: "neutral" },
  code: { label: "Code check", tone: "run" },
};

/** Older experiments may still name a retired kind; show it as is. */
export const kindLabel = (kind: string) => KIND[kind as EvaluatorKind]?.label ?? kind;
